// // PWA lol
// function getFromEnv(config: {
//   param: string;
//   default?: string;
//   required?: boolean;
// }) {
//   if (!config.required && !config.default) {
//     throw new Error(
//       `Environment variable (${config.param}) is not required but does not have a default`,
//     );
//   }
//   if (Object.keys(process.env).includes(config.param)) {
//     return process.env[config.param];
//   }
//   if (config.required) {
//     throw new Error(
//       `Environment variable (${config.param}) required but not found`,
//     );
//   }
//   return config.default;
// }

const settings = {
  apiUrl: "example",
  apiHost: "api.binst.net",
  apiPort: "443",
  apiTls: true,
  appBaseUrl: "https://binst.net",
  framerate: 60,
  offline: false,
  onlyUseFirstDownloadedImage: false,
  debugWindow: false
};
settings.apiUrl = `https://${settings.apiHost}:${settings.apiPort}`;


// const localApiSettings = {
//   apiUrl: "example",
//   apiHost: "localhost",
//   apiPort: "5051",
//   apiTls: false,
//   framerate: 60,
// };
//
// localApiSettings.apiUrl = `http://${localApiSettings.apiHost}:${localApiSettings.apiPort}`;

export { settings };
